module.exports = __webpack_public_path__ + "img/08.149a4d75.png";